var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.showTool)?_c('vue-editor',{staticClass:"editStyle",attrs:{"editorToolbar":_vm.customToolbar,"useCustomImageHandler":""},on:{"image-added":_vm.handleImageAdded},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }